import { render, staticRenderFns } from "./SortOrder.vue?vue&type=template&id=6d3a4692&scoped=true&"
import script from "./SortOrder.vue?vue&type=script&lang=js&"
export * from "./SortOrder.vue?vue&type=script&lang=js&"
import style0 from "./SortOrder.vue?vue&type=style&index=0&id=6d3a4692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a4692",
  null
  
)

export default component.exports